const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:(?!\d)/i;

// Devolve a URL do site apenas se o protocolo for http/https; sem protocolo assume https.
// Qualquer outro esquema (javascript:, data:, ...) ou valor invalido retorna null.
export function getSafeSiteUrl(site) {
  if (!site || typeof site !== 'string') return null;

  const trimmed = site.trim();
  if (!trimmed) return null;

  const candidate = HAS_SCHEME.test(trimmed) ? trimmed : `https://${trimmed}`;

  try {
    const url = new URL(candidate);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    return url.href;
  } catch (err) {
    return null;
  }
}
